import { useLocation, useNavigate } from 'react-router-dom';
import { isGuestUser } from '@/utils';

type NavItem = { label: string; path: string; icon?: string; disabled?: boolean };

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = !isGuestUser();
  const isActiveLink = (path?: string) => path === location.pathname;

  const navItems: NavItem[] = [
    { label: 'Home', path: '/home', icon: '/icons/new/home.png' },
    { label: 'Inplay', path: '/inplay', icon: '/icons/new/inplay.png' },
    { label: 'Cricket', path: '/all-sports/Cricket', icon: '/icons/new/cricket.png' },
    { label: 'Football', path: '/all-sports/Soccer', icon: '/icons/new/football.png' },
    { label: 'Tennis', path: '/all-sports/Tennis', icon: '/icons/new/tennis.png' },
    { label: 'Horse Racing', path: '/all-sports/Horse Racing', icon: '/icons/new/horse.png' },
    {
      label: 'Greyhound Racing',
      path: '/all-sports/Greyhound Racing',
      icon: '/icons/new/gray.png',
    },

    { label: 'Kabaddi', path: '/all-sports/Kabaddi', icon: '/icons/new/kabaddi.png' },
    { label: 'Politics', path: '/all-sports/Politics', icon: '/icons/new/politics.png' },

    { label: 'All Casino', path: '/casino', icon: '/icons/new/casino.png' },
    ...(isAuthenticated ? [{ label: 'Multi Market', path: '/multi-market' }] : []),
  ];

  const baseClasses = `
    relative
    flex shrink-0 items-center justify-center gap-2
    px-[16px]
    py-[9px]
    text-[13px]
    uppercase
    text-body-inverse
    transition
    whitespace-nowrap
    border-r border-primary/50
  `;

  return (
    <div className="h-8 w-full overflow-x-auto overflow-y-hidden bg-[#343A3F] scrollbar-none">
      <div className="flex h-full w-max min-w-full items-center justify-center">
        {navItems.map((item) => (
          <button
            key={item?.label}
            type="button"
            disabled={item?.disabled}
            className={`${baseClasses} ${item?.disabled ? 'cursor-not-allowed ' : 'hover:bg-primary'} ${!item?.disabled && isActiveLink(item?.path) ? 'bg-primary text-black' : ''}`}
            onClick={() => {
              if (item?.path) navigate(item?.path);
            }}
          >
            {item?.icon && <img src={item.icon} alt="" className="size-4 object-contain" />}
        <span className={isActiveLink(item?.path) ? 'text-black' : ''}>
  {item?.label}
</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
